import { useState } from "react";

import axios from "axios";
import { ERROR } from "constant/message";
import { USER_DATA_STORAGE } from "constant";
import { useNavigate } from "react-router-dom";

export default function servicesAPI() {
  const [isLoading, setIsLoading] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const timeOut = 10000;
  const { REACT_APP_API_URL } = process.env;
  const navigate = useNavigate();

  function handleLoad(value) {
    setIsAlert(value.isAlert);
    setMessage(value.message);
    setAlertSeverity(value.alertSeverity);
    setIsLoading(value.isLoading);
  }
  function handleError(error) {
    let errorMessage = error?.response?.data?.errorDetails ?? error?.message;

    if (error?.response?.status === 403) {
      errorMessage = "Une double connexion a été détectée. Veuillez vous reconnecter";
    } else if (error?.response?.status === 401) {
      // console.log("ddddMMM", error?.response?.status);
      errorMessage = "Session invalide. Veuillez vous reconnecter";
    } else if (error?.message === "Network Error") {
      errorMessage = "Vérifier votre connexion internet";
    } else if (error?.code === "ECONNABORTED") {
      errorMessage = "Votre connexion internet est instable ";
    } else if (errorMessage.includes("unique_num_tel_constraint")) {
      errorMessage = "Ce numéro de téléphone est attribué à un autre utilisateur";
    } else if (
      errorMessage.includes("There are already existing ids in the semence") ||
      errorMessage.includes("There are already existing dose semence ids")
    ) {
      errorMessage = "Cette Dose de semence existe déjà";
    } else if (JSON.stringify(error?.response?.data)?.includes("Current password is incorrect.")) {
      errorMessage = "Le mot de passe actuel est incorrect";
    } else if (
      JSON.stringify(error?.response?.data.msg)?.includes("JWT expired.") ||
      JSON.stringify(error?.response?.data.msg)?.includes("token revoked or expired")
    ) {
      errorMessage = "Session expirée, Veuillez vous reconnecter";
    }
    const loadData = {
      isAlert: true,
      message: errorMessage,
      isLoading: false,
      alertSeverity: "error",
    };
    // console.log("error", errorMessage);
    handleLoad(loadData);
  }
  const api = axios.create({
    baseURL: REACT_APP_API_URL,
    timeout: timeOut,
    withCredentials: true,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
  });

  api.interceptors.request.use((config) => {
    const csrfToken = document.cookie
      .split("; ")
      .find((row) => row.startsWith("XSRF-TOKEN="))
      ?.split("=")[1];
    if (csrfToken) {
      const updatedConfig = {
        ...config,
        headers: { ...config.headers, "X-XSRF-TOKEN": csrfToken },
      };
      return updatedConfig;
    }

    return config;
  });
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      console.error("API error £££", error);
      if (
        error?.response?.status === 401 ||
        error?.response?.data?.msg?.includes("JWT expired") ||
        error?.response?.data?.errorDetails?.includes("JWT expired") ||
        error?.response?.data?.msg?.includes("token revoked or expired") ||
        error?.response?.data?.errorDetails?.includes("token revoked or expired") ||
        error?.response?.data?.msg?.includes("Unauthorized") ||
        error?.response?.data?.errorDetails?.includes("Unauthorized") ||
        error?.response?.data?.msg?.includes("Authentication failed") ||
        error?.response?.data?.errorDetails?.includes("Authentication failed")
      ) {
        const loadData = {
          isAlert: true,
          message: "Session expirée. Veuillez vous reconnecter",
          isLoading: false,
          alertSeverity: "error",
        };
        handleLoad(loadData);
        // handleLogout();
      } else if (error?.response?.status === 403) {
        const loadData = {
          isAlert: true,
          message: "Session Invalide. Veuillez vous reconnecter",
          isLoading: false,
          alertSeverity: "error",
        };
        handleLoad(loadData);
      } else {
        handleError(error);
      }
      return Promise.reject(error);
    }
  );

  /* const handleLogout = async () => {
    try {
      const userInfo = localStorage.getItem(USER_DATA_STORAGE);

      if (!userInfo) {
        handleLoad({
          isAlert: true,
          message: "Utilisateur non authentifié. Veuillez vous reconnecter",
          isLoading: false,
          alertSeverity: "error",
        });
        return ERROR;
      }

      handleLoad({
        isAlert: true,
        message: "",
        isLoading: true,
        alertSeverity: "info",
      });
      const response = await api.post("/auth/logout", {});

      console.log("Logout successful", response);

      localStorage.clear();

      setTimeout(() => {
        handleLoad({
          isAlert: false,
          message: "",
          isLoading: false,
          alertSeverity: "info",
        });
        navigate("/sign-in");
      }, 2000);

      return response;
    } catch (error) {
      console.error("Logout error", error);
      return ERROR;
    }
  }; */

  // Récupération d'une liste de donnée en fonction de l'endpoint
  const getData = (endPointURL) => {
    let loadData = {
      isAlert: false,
      message: "",
      isLoading: false,
      alertSeverity: "",
    };
    let resultData = null;
    try {
      const UserInfo = localStorage.getItem(USER_DATA_STORAGE);
      if (UserInfo !== null) {
        // const accessToken = JSON.parse(UserInfo);
        /* const config = {
          // timeout: 10000,
          // headers: { Authorization: `Bearer ${accessToken.access_token}` },
        }; */
        loadData = { isAlert: false, message: "", isLoading: true, alertSeverity: "info" };
        handleLoad(loadData);
        /* resultData = axios
          .get(`${REACT_APP_API_URL}/${endPointURL}`, config) */
        resultData = api
          .get(`/${endPointURL}`)
          .then((response) => {
            const result = response.data;
            let returnData = [];
            // Si le résultat est un tableau de donnée
            if (Array.isArray(result) && result.length > 0) {
              loadData = {
                isAlert: false,
                message: "",
                isLoading: false,
                alertSeverity: "success",
              };
              handleLoad(loadData);
              returnData = result;
            } else {
              loadData = {
                isAlert: false,
                message: "Aucune Données Trouvées",
                isLoading: false,
                alertSeverity: "error",
              };
              handleLoad(loadData);
              returnData = result;
            }

            return returnData;
          })
          .catch((error) => {
            console.error("API error //", error?.response?.status);
            // handleError(error);
            // resultData = ERROR;
            return ERROR;
          });
      } else {
        loadData = {
          isAlert: true,
          message: "Utilisateur non authentifié. Veuillez vous reconnecter",
          isLoading: false,
          alertSeverity: "error",
        };
        handleLoad(loadData);
        // handleLogout();
        // resultData = ERROR;
        return ERROR;
      }
    } catch (error) {
      loadData = { isAlert: true, message: `${error}`, isLoading: false, alertSeverity: "error" };
      handleLoad(loadData);
      // resultData = ERROR;
      return ERROR;
    }
    return resultData;
  };
  const getDataUser = (endPointURL) => {
    let loadData = {
      isAlert: false,
      message: "",
      isLoading: false,
      alertSeverity: "",
    };
    let resultData = null;
    try {
      const UserInfo = localStorage.getItem(USER_DATA_STORAGE);
      if (UserInfo !== null) {
        /* const accessToken = JSON.parse(UserInfo);
        const config = {
          timeout: 10000,
          headers: { Authorization: `Bearer ${accessToken.access_token}` },
        }; */
        loadData = { isAlert: false, message: "", isLoading: true, alertSeverity: "info" };
        handleLoad(loadData);
        /* resultData = axios
          .get(`${REACT_APP_API_URL}/${endPointURL}`, config) */
        resultData = api
          .get(`/${endPointURL}`)
          .then((response) => {
            const result = response.data;
            let returnData = null;
            loadData = {
              isAlert: false,
              message: "",
              isLoading: false,
              alertSeverity: "success",
            };
            handleLoad(loadData);
            returnData = result;

            return returnData;
          })
          .catch((error) => {
            console.error("API error //", error?.response?.status);
            // handleError(error);
            return ERROR;
          });
      } else {
        loadData = {
          isAlert: true,
          message: "Utilisateur non authentifié. Veuillez vous reconnecter",
          isLoading: false,
          alertSeverity: "error",
        };
        handleLoad(loadData);
        // handleLogout();
        // resultData = ERROR;
        return ERROR;
      }
    } catch (error) {
      loadData = { isAlert: true, message: `${error}`, isLoading: false, alertSeverity: "error" };
      handleLoad(loadData);
      return ERROR;
    }
    return resultData;
  };
  const getDataDashboard = (endPointURL) => {
    let loadData = {
      isAlert: false,
      message: "",
      isLoading: false,
      alertSeverity: "",
    };
    let resultData = null;
    try {
      const UserInfo = localStorage.getItem(USER_DATA_STORAGE);
      if (UserInfo !== null) {
        // const accessToken = JSON.parse(UserInfo);
        /* const config = {
          timeout: 10000,
          headers: { Authorization: `Bearer ${accessToken.access_token}` },
        }; */

        loadData = { isAlert: false, message: "", isLoading: true, alertSeverity: "info" };
        handleLoad(loadData);
        /* resultData = axios
          .get(`${REACT_APP_API_URL}/${endPointURL}`, config) */
        resultData = api
          .get(`/${endPointURL}`)
          .then((response) => {
            const result = response.data;
            let returnData = null;
            loadData = {
              isAlert: false,
              message: "",
              isLoading: false,
              alertSeverity: "success",
            };
            handleLoad(loadData);
            returnData = result;

            return returnData;
          })
          .catch((error) => {
            // handleError(error);
            console.error("API error //", error?.response?.status);
            return ERROR;
          });
      } else {
        loadData = {
          isAlert: true,
          message: "Utilisateur non authentifié. Veuillez vous reconnecter",
          isLoading: false,
          alertSeverity: "error",
        };
        handleLoad(loadData);
        // handleLogout();
        // resultData = ERROR;
        return ERROR;
      }
    } catch (error) {
      loadData = { isAlert: true, message: `${error}`, isLoading: false, alertSeverity: "error" };
      handleLoad(loadData);
      return ERROR;
    }
    return resultData;
  };
  // Enregistrement de donnée en fonction de l'endpoint
  const postData = async (endPointURL, dataPost) => {
    let loadData = {
      isAlert: false,
      message: "",
      isLoading: false,
      alertSeverity: "",
    };
    let resultData = null;

    try {
      // await api.get("/csrf");
      const UserInfo = localStorage.getItem(USER_DATA_STORAGE);
      /* if (endPointURL === "Users/password/update") {
        UserInfo = connectedUser;
      } */
      if (UserInfo !== null) {
        /* let accessToken = UserInfo;
        if (endPointURL !== "Users/password/update") {
          accessToken = JSON.parse(UserInfo);
        }
        const config = {
          timeout: 10000,
          headers: { Authorization: `Bearer ${accessToken.access_token}` },
        }; */

        loadData = { isAlert: false, message: "", isLoading: true, alertSeverity: "info" };
        handleLoad(loadData);
        /* resultData = axios
          .post(`${REACT_APP_API_URL}/${endPointURL}`, dataPost, config) */
        resultData = api
          .post(`/${endPointURL}`, dataPost)
          .then((response) => {
            const result = response.data;

            loadData = { isAlert: false, message: "", isLoading: false, alertSeverity: "info" };
            handleLoad(loadData);

            return result;
          })
          .catch((error) => {
            console.error("API error // ooo", endPointURL, error?.response?.status);
            // handleError(error);
            if (
              endPointURL === "auth/logout" &&
              (error?.response?.status === 401 || error?.response?.status === 403)
            ) {
              localStorage.clear();
              setTimeout(() => {
                navigate("/");
              }, 500);
            }
            return ERROR;
          });
      } else {
        loadData = {
          isAlert: true,
          message: "Utilisateur non authentifié. Veuillez vous reconnecter",
          isLoading: false,
          alertSeverity: "error",
        };
        handleLoad(loadData);
        // handleLogout();
        // resultData = ERROR;
        return ERROR;
      }
    } catch (error) {
      loadData = { isAlert: true, message: `${error}`, isLoading: false, alertSeverity: "error" };
      handleLoad(loadData);
      return ERROR;
    }
    return resultData;
  };
  const putData = (endPointURL, dataPost) => {
    let loadData = {
      isAlert: false,
      message: "",
      isLoading: false,
      alertSeverity: "",
    };
    let resultData = null;

    try {
      const UserInfo = localStorage.getItem(USER_DATA_STORAGE);
      if (UserInfo !== null) {
        /* const accessToken = JSON.parse(UserInfo);
        const config = {
          timeout: 10000,
          headers: { Authorization: `Bearer ${accessToken.access_token}` },
        }; */

        loadData = { isAlert: false, message: "", isLoading: true, alertSeverity: "info" };
        handleLoad(loadData);
        /* resultData = axios
          .put(`${REACT_APP_API_URL}/${endPointURL}`, dataPost, config) */
        resultData = api
          .put(`/${endPointURL}`, dataPost)
          .then((response) => {
            const result = response.data;

            loadData = { isAlert: false, message: "", isLoading: false, alertSeverity: "info" };
            handleLoad(loadData);

            return result;
          })
          .catch((error) => {
            console.error("API error //", error?.response?.status);
            // handleError(error);
            return ERROR;
          });
      } else {
        loadData = {
          isAlert: true,
          message: "Utilisateur non authentifié. Veuillez vous reconnecter",
          isLoading: false,
          alertSeverity: "error",
        };
        handleLoad(loadData);
        // handleLogout();
        // resultData = ERROR;
        return ERROR;
      }
    } catch (error) {
      loadData = { isAlert: true, message: `${error}`, isLoading: false, alertSeverity: "error" };
      handleLoad(loadData);
      return ERROR;
    }
    return resultData;
  };

  return {
    getData,
    isLoading,
    isAlert,
    message,
    alertSeverity,
    handleLoad,
    postData,
    getDataUser,
    getDataDashboard,
    putData,
    // handleLogout,
    api,
  };
}
